import classNames from "classnames";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscCharacterQuoteCard.module.scss";

export interface AscCharacterQuoteCardProps {
  text?: string;
  className?: string;
  loading?: boolean;
}

export default function AscCharacterQuoteCard({
  text = "Place for all characters together maybe with tips and small info about this section",
  className,
  loading = false,
}: AscCharacterQuoteCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, className)}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      contentClassName={styles.cardContent}
      title={null}
      coverImageUrl={null}
      data-testid="asc-character-quote-card"
      loading={loading}
    >
      {text}
    </AscGenericCard>
  );
}
